import { createFileRoute } from '@tanstack/react-router';
import { PartnershipsPage } from '@/features/spaces/pages/partnerships-page';

/** The partnership requests and the partner spaces of the organisation (its owners and administrators). */
export const Route = createFileRoute('/_auth/o/$orgId/partnerships')({
  component: PartnershipsRoute,
});

function PartnershipsRoute() {
  const { orgId } = Route.useParams();
  return <PartnershipsPage orgId={orgId} />;
}
